import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import styles from './departureContainer.module.css';
// Selectors:
import {
  getLinkedDepartures,
  getLinkedOperators,
} from '../../domain/state/linked/selectors';
import { getHasHotels } from '../../domain/state/hotels/selectors';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';
import { List } from '../components/List/List';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';

const mapStateToProps = (state) => ({
  linkedDepartures: getLinkedDepartures(state),
  linkedOperators: getLinkedOperators(state),
  hasHotels: getHasHotels(state),
  modifierStyles: modifierStylesSelector(state),
});

export const DepartureContainer = connect(mapStateToProps)((props) => {
  const { linkedDepartures, linkedOperators, hasHotels, modifierStyles } =
    props;
  const isMobile = useContext(MobileContext);

  if (!hasHotels) {
    return null;
  }

  const departuresAndOperators = [
    {
      name: 'Туроператор',
      linked: linkedOperators,
      showMoreLabel: 'Показать всех туроператоров',
    },
    {
      name: 'Вылеты из городов',
      linked: linkedDepartures,
      showMoreLabel: 'Показать все города',
    },
  ];

  return (
    <div
      className={classnames(styles.container, {
        [styles.containerMobile]: isMobile,
      })}
    >
      {departuresAndOperators.map((list) => {
        const { name, linked, showMoreLabel } = list;

        if (isEmpty(linked)) {
          return null;
        }

        return (
          <div className={styles.wrapper} key={name}>
            <p
              className={classnames(styles.label, {
                [styles.labelBoldTextColor]: modifierStyles?.boldTextColor,
              })}
              style={{
                '--boldTextColor': modifierStyles?.boldTextColor,
              }}
            >
              {name}
            </p>
            <List
              list={linked}
              isMobile={isMobile}
              showMoreLabel={showMoreLabel}
              modifierStyles={modifierStyles}
            />
          </div>
        );
      })}
    </div>
  );
});
